import { c as _c } from "react/compiler-runtime";
import React, { use } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import notFoundNewConsumerApp from 'commons/notFoundNewConsumerApp';
import PDPDesktop from './PDPDesktop';
import PDPMobile from './PDPMobile';
import Component404 from '../404';
import MobileAndTabletOnly from '../MobileAndTabletOnly';
import DesktopOnly from '../DesktopOnly';
import PDPSEOTags from './PDPSEOTags';
import PDPFooter from './PDPFooter';
import PDPContext from './state/context/PDPContext';
import usePDPLuxAnalytics from './hooks/usePDPLuxAnalytics';
import usePDPCreateContextValue from './hooks/usePDPCreateContextValue';
import PDPPageAnalytics from './PDPPageAnalytics';
import SuspenseWithLoader from '../SuspenseWithLoader';
import PDPPlaceholder from './PDPPlaceholder';
const PDPInner = t0 => {
  const $ = _c(35);
  const {
    slugOverride: t1,
    isEditOrder: t2,
    pdpIsModularBYOProduct: t3,
    productOptionsPromise
  } = t0;
  const slugOverride = t1 === undefined ? null : t1;
  const isEditOrder = t2 === undefined ? false : t2;
  const pdpIsModularBYOProduct = t3 === undefined ? false : t3;
  const params = useParams();
  const slug = slugOverride ?? params.slug ?? null;
  const productOptions = productOptionsPromise ? use(productOptionsPromise) : null;
  let t4;
  if ($[0] !== isEditOrder || $[1] !== pdpIsModularBYOProduct || $[2] !== productOptions || $[3] !== slug) {
    t4 = {
      isEditOrder,
      pdpIsModularBYOProduct,
      slug,
      productOptions
    };
    $[0] = isEditOrder;
    $[1] = pdpIsModularBYOProduct;
    $[2] = productOptions;
    $[3] = slug;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const pdpContextValue = usePDPCreateContextValue(t4);
  usePDPLuxAnalytics();
  if (pdpContextValue.basicDetails.isProductNotFound) {
    if (!isNewConsumerApp) {
      let t5;
      if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <Component404 />;
        $[5] = t5;
      } else {
        t5 = $[5];
      }
      return t5;
    }
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = notFoundNewConsumerApp();
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    return t5;
  }
  let t5;
  if ($[7] !== pdpContextValue.stockAvailability?.data) {
    t5 = pdpContextValue.stockAvailability?.data || {};
    $[7] = pdpContextValue.stockAvailability?.data;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const {
    discontinuedCategoryMsg: t6,
    isDiscontinued: t7,
    isEFGInternal,
    isOutOfStock: t8,
    showNotification
  } = t5;
  const discontinuedCategoryMsg = t6 === undefined ? null : t6;
  const isDiscontinued = t7 === undefined ? false : t7;
  const isOutOfStock = t8 === undefined ? false : t8;
  let t9;
  if ($[9] !== isOutOfStock) {
    t9 = <PDPSEOTags isOutOfStock={isOutOfStock} />;
    $[9] = isOutOfStock;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = isDiscontinued ? discontinuedCategoryMsg : null;
  let t11;
  if ($[11] !== isDiscontinued || $[12] !== isEditOrder || $[13] !== isOutOfStock || $[14] !== pdpIsModularBYOProduct || $[15] !== showNotification || $[16] !== slug || $[17] !== t10) {
    t11 = <MobileAndTabletOnly><PDPMobile slug={slug} isEditOrder={isEditOrder} isOutOfStock={isOutOfStock} showOutOfStockNotification={showNotification} pdpIsModularBYOProduct={pdpIsModularBYOProduct} showDiscontinuedNotification={isDiscontinued} discontinuedCategoryMsg={t10} /></MobileAndTabletOnly>;
    $[11] = isDiscontinued;
    $[12] = isEditOrder;
    $[13] = isOutOfStock;
    $[14] = pdpIsModularBYOProduct;
    $[15] = showNotification;
    $[16] = slug;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const t12 = isDiscontinued ? discontinuedCategoryMsg : null;
  let t13;
  if ($[19] !== isDiscontinued || $[20] !== isEFGInternal || $[21] !== isEditOrder || $[22] !== isOutOfStock || $[23] !== pdpIsModularBYOProduct || $[24] !== showNotification || $[25] !== slug || $[26] !== t12) {
    t13 = <DesktopOnly><PDPDesktop slug={slug} isEditOrder={isEditOrder} isOutOfStock={isOutOfStock} showOutOfStockNotification={showNotification} pdpIsModularBYOProduct={pdpIsModularBYOProduct} isEFGInternal={isEFGInternal} showDiscontinuedNotification={isDiscontinued} discontinuedCategoryMsg={t12} /></DesktopOnly>;
    $[19] = isDiscontinued;
    $[20] = isEFGInternal;
    $[21] = isEditOrder;
    $[22] = isOutOfStock;
    $[23] = pdpIsModularBYOProduct;
    $[24] = showNotification;
    $[25] = slug;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  let t15;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <PDPPageAnalytics />;
    t15 = <PDPFooter />;
    $[28] = t14;
    $[29] = t15;
  } else {
    t14 = $[28];
    t15 = $[29];
  }
  let t16;
  if ($[30] !== pdpContextValue || $[31] !== t11 || $[32] !== t13 || $[33] !== t9) {
    t16 = <PDPContext.Provider value={pdpContextValue}>{t9}{t11}{t13}{t14}{t15}</PDPContext.Provider>;
    $[30] = pdpContextValue;
    $[31] = t11;
    $[32] = t13;
    $[33] = t9;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  return t16;
};
const PDP = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PDPPlaceholder />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
PDP.propTypes = {
  slugOverride: PropTypes.string,
  isEditOrder: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool
};
export default PDP;